highlights:
  - title: |
      Published in npj Robotics (Nature Portfolio): Concrete Planning
    video: npj-robotics-paper
    description: |
      Our latest work presents a multi-robot navigation framework for aggressive and coupled coordination, validated with 40 real robots.
    projectPage: https://proroklab.github.io/agile-mapf/
    paperUrl: https://www.nature.com/articles/s44182-026-00083-2
    #
  - title: |
      Project LaCAM
    description: |
      Develop a quick, scalable, and reliable solution for multi-agent pathfinding (MAPF).
    img: pathfinding-10k
    projectPage: https://kei18.github.io/lacam-project/

introTalks:
  - title: |
      From Scalable MAPF to Capable Multi-Robot Coordination (Autonomy Talks at MIT, 2026)
    img: https://img.youtube.com/vi/xI84VltsVRw/hqdefault.jpg
    description: |
      Beginner-friendly introduction to large-scale multi-agent multi-robot coordination. 1 hour.
    youtube: https://www.youtube.com/watch?v=xI84VltsVRw
  - title: |
      Upgrading Multi-Agent Pathfinding for the Real World (EurMAPF-25)
    img: https://img.youtube.com/vi/XeZTyUS8ZF0/hqdefault.jpg
    description: |
      Deeper introduction to MAPF research directions and practical deployment.
      1 hour.
    youtube: https://www.youtube.com/watch?v=XeZTyUS8ZF0
    speakerdeck: https://speakerdeck.com/kei18/eurmapf-25-upgrading-mapf

future:
  - year: 2026
    month: 11
    name:
      en: CoRL-26 in Austin 🇺🇸
      ja: CoRL-26 @オースティンに参加予定です
    url: https://www.corl.org/

activities:
  - month: 10
    name:
      en: IROS-26 tutorial on MAPF is now available on YouTube
      ja: IROS-26 で行った MAPF のチュートリアルが YouTube で公開されました
    url: https://www.youtube.com/watch?v=EkfmFfDh9N0
    year: 2026
  - month: 10
    name:
      en: |
        Our paper "Denoising Multi-Robot Trajectories" has been published at IEEE T-RO!
      ja: |
        論文 "Denoising Multi-Robot Trajectories" が IEEE T-RO に掲載されました!
    year: 2026
    url: https://ieeexplore.ieee.org/document/11731799
  - year: 2026
    month: 10
    name:
      en: Tutorial at IROS-26 in Pittsburgh 🇺🇸 about MAPF with real-robots
      ja: IROS-26 @ピッツバーグで MAPF の実ロボット展開に関するチュートリアルを行いました
    url: https://sites.google.com/view/iros-26-mapf-tutorial/home
  - month: 9
    name:
      en: |
        Visited MIT, Amazon Robotics, and Boston Dynamics 🇺🇸 Cool discussions!
      ja: |
        MIT, Amazon Robotics, Boston Dynamics@ボストンを訪問しました
    year: 2026
  - month: 9
    name:
      en: |
        Talk at Osaka University (Online)
      ja: |
        大阪大学MMDS AI・データ利活用研究会でオンライン講演を行いました
    year: 2026
    url: https://www-mmds.sigmath.es.osaka-u.ac.jp/structure/activity/ai_data.php?id=117
  - month: 9
    name:
      en: |
        A paper on multi-robot imitation learning got accepted to CoRL-26!
      ja: |
        マルチロボット学習に関する論文が CoRL-26 に採択されました!
    url: https://www.corl.org/
    year: 2026
  - month: 8
    name:
      en: |
        Visited Cambridge 🇬🇧
      ja: |
        ケンブリッジ大を訪問しました
    year: 2026
  - month: 8
    name:
      en: |
        Visited the IMRC lab at TU Berlin 🇩🇪
      ja: |
        IMRC Lab, TU Berlin を訪問しました
    year: 2026
    url: https://imrclab.github.io/
  - month: 8
    name:
      en: |
        IJCAI-26 in Bremen 🇩🇪
      ja: |
        IJCAI-26 @ブレーメンに参加しました
    year: 2026
    url: https://2026.ijcai.org/
  - month: 8
    name:
      en: |
        SoCS-26 in Bremerhaven 🇩🇪
      ja: |
        SoCS-26 @ブレーマーハーフェンに参加しました
    year: 2026
    url: https://socs26.search-conference.org/home
  - month: 8
    name:
      en: We got the SoCS 2026 Best Student Paper Award for Lifelong LaCAM 🏆
      ja: Lifelong LaCAM の論文に関して The SoCS 2026 Best Student Paper Awardを受賞しました 🏆
    url: https://socs26.search-conference.org/
    year: 2026
  - month: 6
    name:
      en: |
        ICAPS-26 in Dublin 🇮🇪
      ja: |
        ICAPS-26@ダブリンに参加しました
    year: 2026
    url: https://icaps26.icaps-conference.org/
  - month: 6
    name:
      en: |
        Online talk at AI Robotics Lab, Sogang University 🇰🇷
      ja: |
        AI Robotics Lab, Sogang University 🇰🇷 でオンライン講演をしました
    url: https://airobotics.sogang.ac.kr/
    year: 2026
  - name:
      en: |
        JSAI-26 in Takasaki 🇯🇵
      ja: |
        JSAI2026@高崎に参加し, オーガナイズドセッションの開催, 展示等を行いました
    url: https://www.ai-gakkai.or.jp/jsai2026/os/#os-1
    month: 6
    year: 2026
  # - month: 5
  #   name:
  #     en: |
  #       A preprint paper "Lifelong LaCAM with Local Guidance for Lifelong MAPF" is out on arXiv (to be presented in SoCS-26)
  #     ja: |
  #       論文 "Lifelong LaCAM with Local Guidance for Lifelong MAPF" のプレプリントをarXivに公開しました (SoCS-26で発表予定)
  #   url: https://arxiv.org/abs/2605.16855
  #   year: 2026
  #   #
  # - month: 5
  #   name:
  #     en: |
  #       A preprint paper "From Gridworlds to Warehouses: Adapting Lightweight One-shot Multi-Agent Pathfinding for AGVs" is out on arXiv (to be presented in IJCAI-26)
  #     ja: |
  #       論文 "From Gridworlds to Warehouses: Adapting Lightweight One-shot Multi-Agent Pathfinding for AGVs" のプレプリントをarXivに公開しました (IJCAI-26で発表予定)
  #   url: https://arxiv.org/abs/2605.15799
  #   year: 2026
  #   #
  - month: 5
    name:
      en: |
        Two papers (TAPF and LLLG) got accepted to SoCS-26!
      ja: |
        MAPFに関する論文2報 (TAPF, LLLG) が SoCS-26 に採択されました!
    url: https://socs26.search-conference.org/home
    year: 2026
    #
  # - month: 5
  #   name:
  #     en: |
  #       A preprint paper "Conveyor Parcel Routing with Order-Contiguous Arrivals" is out on arXiv
  #     ja: |
  #       論文 "Conveyor Parcel Routing with Order-Contiguous Arrivals" のプレプリントをarXivに公開しました
  #   url: https://arxiv.org/abs/2605.13035
  #   year: 2026
  #   #
  # - month: 5
  #   name:
  #     en: |
  #       A preprint paper "Distance-Constrained Unlabeled Multi-Agent Pathfinding" is out on arXiv
  #     ja: |
  #       論文 "Distance-Constrained Unlabeled Multi-Agent Pathfinding" のプレプリントをarXivに公開しました
  #   url: https://arxiv.org/abs/2605.11503
  #   year: 2026
  # - month: 5
  #   name:
  #     en: |
  #       A preprint paper "Alternating Target–Path Planning for Scalable Multi-Agent Coordination" is out on arXiv
  #     ja: |
  #       論文 "Alternating Target–Path Planning for Scalable Multi-Agent Coordination" のプレプリントをarXivに公開しました
  #   url: https://arxiv.org/abs/2605.07744
  #   year: 2026
  #
  - month: 5
    name:
      en: |
        A paper on MAPF tailored to warehouse setups has been accepted to IJCAI-26!
      ja: |
        倉庫環境における MAPF の論文が IJCAI-26 に採択されました!
    url: https://2026.ijcai.org/
    year: 2026
  - month: 4
    name:
      en: |
        Online talk at IDM Lab, USC/UCI 🇺🇸
      ja: |
        IDM Lab@USC/UCI のセミナーで講演をしました
    year: 2026
  - month: 4
    name:
      en: |
        Online talk at Hitotsubashi University 🇯🇵
      ja: |
        一橋大学大学院ソーシャル・データサイエンス研究科で講演をしました
    year: 2026
    url: https://www.sds.hit-u.ac.jp/3940/
  - month: 4
    name:
      en: |
        Our npj Robotics paper is featured on the journal homepage as a hero image
      ja: |
        Concrete Planning の論文が npj Robotics (Nature Portfolio) のホームページでヒーローイメージとして紹介されています
    year: 2026
    url: https://www.nature.com/npjrobot/
  - month: 3
    name:
      en: |
        Our npj Robotics paper is featured in IEEE Spectrum Video Friday
      ja: |
        npj Robotics に掲載された論文が IEEE Spectrum Video Friday に掲載されました
    year: 2026
    url: https://spectrum.ieee.org/roadrunner-bipedal-robot#41kpw6jwxty
  - month: 3
    name:
      en: |
        Our paper "Concrete multi-agent path planning enabling kinodynamically aggressive maneuvers" has been published at npj Robotics (Nature Portfolio)!
      ja: |
        論文 "Concrete multi-agent path planning enabling kinodynamically aggressive maneuvers" が npj Robotics (Nature Portfolio) に掲載されました!
    year: 2026
    url: https://www.nature.com/articles/s44182-026-00083-2
  - month: 3
    name:
      en: |
        Online talk at Autonomy Talks at MIT
      ja: |
        Autonomy Talks (MIT) でオンライン講演を行いました
    year: 2026
    url: https://www.youtube.com/watch?v=xI84VltsVRw
  # - month: 3
  #   name:
  #     en: |
  #       At IPSJ-26 in Matsuyama, my mentee, Ueshima-san received the Student Encouragement Award for his presentation, "Solving Discrete Multi-Robot Coordination via Deformation Denoising." Congrats!
  #     ja: |
  #       IPSJ-26@松山にてインターン生の上島さんの発表 「デノイジング機構を用いた離散マルチロボット協調への汎用的アプローチ」が学生奨励賞を受賞しました. おめでとうございます!
  #   year: 2026
  #   url: https://www.ipsj.or.jp/event/taikai/88/index.html
  - month: 2
    name:
      en: |
        Received the Funai Information Technology Award for Young Researchers!
      ja: |
        船井研究奨励賞を受賞しました
    url: https://funaifoundation.jp/news-580.htm
    year: 2026
  - month: 2
    name:
      en: |
        Two papers (CUMAPF and db-LaCAM) got accepted to ICAPS-26!
      ja: |
        MAPFに関する論文2報 (CUMAPF, db-LaCAM) が ICAPS-26 に採択されました!
    url: https://icaps26.icaps-conference.org/
    year: 2026
  - month: 1
    name:
      en: |
        A paper "Pairwise is Not Enough: Hypergraph Neural Networks for Multi-Agent Pathfinding" got accepted to ICLR-26!
      ja: |
        論文 "Pairwise is Not Enough: Hypergraph Neural Networks for Multi-Agent Pathfinding" が ICLR-26 に採択されました
    url: https://iclr.cc/
    year: 2026
  - month: 1
    name:
      en: |
        Two papers (db-LaCAM, HMAGAT) + panel discussion at WoMAPF-26, Singapore.
      ja: |
        WoMAPF-26@シンガポールで発表2報を行い (db-LaCAM, HMAGAT)、またパネリストとして登壇しました
    year: 2026
    url: https://mapf-workshop.github.io/aaai26/
    #
  - month: 1
    name:
      en: |
        Presented two papers (local guidance, LaGAT) at AAAI-26 in Singapore
      ja: |
        シンガポールで開催されたAAAI-26に参加して論文2報を発表しました (local guidance, LaGAT)
    year: 2026
    url: https://aaai.org/conference/aaai/aaai-26/
  - month: 12
    name:
      en: |
        A paper "100-Mouse System: Scalable Multi-Robot Testbed with State Management User Interface" has been published at Journal of Robotics and Mechatronics (JRM)!
      ja: |
        論文 "100-Mouse System: Scalable Multi-Robot Testbed with State Management User Interface" が Journal of Robotics and Mechatronics (JRM)  に掲載されました
    url: https://www.fujipress.jp/jrm/rb/robot003700061545/
    year: 2025
  #
  - month: 12
    name:
      en: |
        Moved from Cambridge to Tokyo. What a wonderful time I had in the UK!
      ja: |
        ケンブリッジから東京に引越しました
    year: 2025
    #
  - month: 12
    name:
      en: |
        A preprint paper "db-LaCAM: Fast and Scalable Multi-Robot Kinodynamic Motion Planning with Discontinuity-Bounded Search and Lightweight MAPF" is out on arXiv
      ja: |
        論文 "db-LaCAM: Fast and Scalable Multi-Robot Kinodynamic Motion Planning with Discontinuity-Bounded Search and Lightweight MAPF" のプレプリントをarXivに公開しました
    url: https://arxiv.org/abs/2512.06796
    year: 2025
  - month: 11
    name:
      en: |
        Two papers on MAPF (GNN x LaCAM, local guidance) got accepted to AAAI-26!
      ja: |
        MAPFに関する論文2報 (GNN x LaCAM, local guidance) がAAAI-26に採択されました!
    url: https://aaai.org/conference/aaai/aaai-26/
    year: 2025
  - name:
      en: |
        Featured in Fantástico, Brazil’s TV show (3:00-), about Prorok Lab research in Cambridge
      ja: |
        ブラジルのTVショーFantásticoにケンブリッジ大での研究が紹介されました (3:00-)
    url: https://g1.globo.com/fantastico/video/mentes-digitais-professora-brasileira-lidera-pesquisas-de-inteligencia-coletiva-no-reino-unido-14044982.ghtml
    month: 10
    year: 2025
  - month: 10
    name:
      en: |
        Invited talk at EurMAPF-25 in Bologna, Italy
      ja: |
        イタリア・ボローニャで開催されるEurMAPF-25で招待講演を行いました
    year: 2025
    url: https://sites.google.com/view/eurmapf25
  - month: 10
    name:
      en: |
        A preprint paper "Polynomial-time Configuration Generator for Connected Unlabeled Multi-Agent Pathfinding" is out on arXiv
      ja: |
        論文 "Polynomial-time Configuration Generator for Connected Unlabeled Multi-Agent Pathfinding" のプレプリントをarXivに公開しました
    url: https://arxiv.org/abs/2510.19567
    year: 2025
  - month: 10
    name:
      en: |
        A preprint paper "Local Guidance for Configuration-Based Multi-Agent Pathfinding" is out on arXiv
      ja: |
        論文 "Local Guidance for Configuration-Based Multi-Agent Pathfinding" のプレプリントをarXivに公開しました
    url: https://arxiv.org/abs/2510.19072
    year: 2025
  - month: 10
    name:
      en: |
        A preprint paper "Graph Attention-Guided Search for Dense Multi-Agent Pathfinding" is out on arXiv
      ja: |
        論文 "Graph Attention-Guided Search for Dense Multi-Agent Pathfinding" のプレプリントをarXivに公開しました
    url: https://arxiv.org/abs/2510.17382
    year: 2025
  - month: 9
    name:
      en: |
        OPTDS-25 in Tokyo: One talk
      ja: |
        東京で開催されたOPTDS-25に参加して講演を行いました
    year: 2025
    url: https://sites.google.com/view/optds2025/
  - month: 9
    name:
      en: |
        Research grant acceptance: JST PRESTO "Real-World Intelligence Fundamentals"
      ja: |
        JST さきがけ「実世界知能システムの基盤創出」に採択されました
    url:
      ja: https://www.jst.go.jp/kisoken/presto/application/2025/250918/250918.html
      en: https://www.jst.go.jp/kisoken/presto/en/research_area/area2025-3.html
    year: 2025
    #
  - month: 8
    name:
      en: |
        I really enjoyed SoCS-25 in Glasgow!
      ja: |
        英グラスゴーで開催されたSoCS-25に参加して研究発表を行いました
    year: 2025
    url: https://socs25.search-conference.org/home
  - month: 8
    name:
      en: A paper "Congestion Mitigation Path Planning for Large-Scale Multi-Agent Navigation in Dense Environments" has been accepted to IEEE RA-L!
      ja: 論文 "Congestion Mitigation Path Planning for Large-Scale Multi-Agent Navigation in Dense Environments" が IEEE RA-L に採択されました
    url: https://arxiv.org/abs/2508.05253
    year: 2025
    #
  - month: 7
    name:
      en: |
        A paper "ReCoDe: Reinforcement Learning-based Dynamic Constraint Design for Multi-Agent Coordination" got accepted to CoRL-25!
      ja: |
        論文"ReCoDe: Reinforcement Learning-based Dynamic Constraint Design for Multi-Agent Coordination" がCoRL-25に採択されました
    url: https://www.corl.org/
    year: 2025
    #
  - month: 7
    name:
      en: |
        A preprint paper "LF: Online Multi-Robot Path Planning Meets Optimal Trajectory Control" is out on arXiv
      ja: |
        論文 "LF: Online Multi-Robot Path Planning Meets Optimal Trajectory Control" のプレプリントをarXivに公開しました
    url: https://arxiv.org/abs/2507.11464
    year: 2025
  - month: 7
    name:
      en: |
        A technical report "Sanity: An Agile Brushless Quadrotor for Multi-Agent Experiments" is out on OpenReview
      ja: |
        テクニカルレポート "Sanity: An Agile Brushless Quadrotor for Multi-Agent Experiments" を公開しました
    url: https://openreview.net/forum?id=i5dKOANPZZ
    year: 2025
  - month: 6
    name:
      en: |
        A paper on diffusion denoising for multi-robot trajectory optimisation has been accepted to IROS-25!
      ja: |
        拡散モデルのノイズ除去を利用したマルチロボット軌道最適化の論文が IROS-25 に採択されました!
    url: https://www.iros25.org/
    year: 2025
  - month: 5
    name:
      en: |
        Seminar talk at Behavior in Networks Studies Unit, UTokyo
      ja: |
        東大交通研でセミナートークを行いました.
    url: http://www.trip.t.u-tokyo.ac.jp/
    year: 2025
  - month: 5
    name:
      en: |
        A paper on PIBT tiebreaking has been accepted to SoCS-25! See you in Glasgow this summer
      ja: |
        PIBTのタイブレーキング改善についての論文がSoCS-25 に採択されました!
    url: https://socs25.search-conference.org/home
    year: 2025
  - month: 3
    name:
      en: |
        A preprint paper "D4orm: Multi-Robot Trajectories with Dynamics-aware Diffusion Denoised Deformations" is out on arXiv.
      ja: |
        論文 "D4orm: Multi-Robot Trajectories with Dynamics-aware Diffusion Denoised Deformations" のプレプリントをarXivに公開しました.
    url: https://arxiv.org/abs/2503.12204
    year: 2025
  - name:
      en: |
        Featured in BBC click (18:00-), about Prorok Lab research in Cambridge, including quadrotor swarm coordination
      ja: |
        BBC Click にケンブリッジ大での研究が紹介されました (18:28-)
    url: https://www.bbc.co.uk/iplayer/episode/m0029673/click-15032025
    month: 3
    year: 2025
  - name:
      en: |
        Hosted the 6th international workshop on Multi-Agent Path Finding (WoMAPF) at AAAI-25, with two co-authored presentations.
      ja: |
        AAAI-25 で第6回マルチエージェント経路計画ワークショップ (WoMAPF) を開催しました. 共著を2件発表しました.
    url: https://womapf.github.io/aaai-25/
    month: 3
    year: 2025
  - month: 10
    name:
      en: |
        Visited several robotics labs in Zurich, Switzerland. Cool research discussions!
      ja: |
        スイス・チューリッヒに滞在してロボット系の研究室を訪問しました.
    year: 2024
  - month: 10
    name:
      en: |
        Visited Osaka and Tokyo. Thanks for a lot of cool research discussions!
      ja: |
        大阪・東京に滞在しました.
    year: 2024
  - month: 10
    name:
      en: |
        Organised a workshop on multi-agent/multi-robot planning in Tokyo on 5 October. Thank you for attending!
      ja: |
        マルチエージェント・マルチロボットプランニング研究会を10月5日に東京で主催しました. 参加していただき、ありがとうございました！
    url: https://sites.google.com/view/multi-agent-robot-planning-24
    year: 2024
  - month: 8
    name:
      en: |
        A preprint paper "Pathfinding with Lazy Successor Generation" is out on arXiv.
      ja: |
        主著論文 "Pathfinding with Lazy Successor Generation"のプレプリントをarXivに公開しました.
    url: https://arxiv.org/abs/2408.15443
    year: 2024
    #
  - month: 5
    name:
      en: |
        Visited Monash University in Melbourne, and University of Technology Sydney. Did a lot of cool research discussions!
      ja: |
        オーストラリア・モナシュ大学とシドニー工科大学を訪問しました.
    year: 2024
  - month: 5
    name:
      en: |
        Invited talk at Agents-VIC Autumn Symposium 2024 in Melbourne, Australia
      ja: |
        Agents-VIC Autumn Symposium 2024 (オーストラリア・メルボルン) で招待講演を行いました
    url: https://sites.google.com/view/agentsvic-autumn2024/home
    year: 2024
  - month: 5
    name:
      en: One talk (engineering LaCAM*) at AAMAS-24 in Auckland, New Zealand.
      ja: AAMAS-24@ニュージーランド・オークランドで研究発表を行いました
    url: https://www.aamas2024-conference.auckland.ac.nz/
    year: 2024
  - month: 4
    name:
      en: Co-authored paper "A Comprehensive Review on Leveraging Machine Learning for Multi-Agent Path Finding" has been published at IEEE Access!
      ja: 共著論文 "A Comprehensive Review on Leveraging Machine Learning for Multi-Agent Path Finding" が IEEE Access に掲載されました
    url: https://ieeexplore.ieee.org/document/10506521
    year: 2024
  - month: 3
    year: 2024
    name:
      en: |
        Received the Ph.D. Dissertation Award (Seiichi Tejima Research Award) from TokyoTech!
        Thanks to many supporters, especially my supervisor Xavier.
      ja: |
        手島精一記念研究賞 (博士論文賞) を東工大より受賞しました.
        博士課程を支えてくれた方々, 特に指導教員のDefago先生に深く感謝します.
    url: https://www.titech.ac.jp/news/2024/069180
  - month: 2
    name:
      en: Visited idealworks in Munich, Germany
      ja: idealworks (ミュンヘン・ドイツ) を訪問しました
    url: https://idealworks.com/en/
    year: 2024
  - month: 2
    name:
      en: Guest lecture at Carnegie Mellon University
      ja: アメリカ・カーネギーメロン大学でゲストレクチャーをしました
    url: https://jiaoyangli.me/teaching/2024-spring-16891
    year: 2024
  - month: 1
    name:
      en: |
        A feature article for my PhD dissertation has appeared in JSAI (Journal of the Japanese Society for Artificial Intelligence)
      ja: |
        人工知能学会誌・博士論文集に記事が掲載されました
    url: https://doi.org/10.11517/jjsai.39.1_50
    year: 2024
  - month: 1
    name:
      en: |
        Renew blog site
      ja: |
        ブログをリニューアルしました
    url: https://kei18.github.io/note
    year: 2024
  - month: 12
    name:
      en: |
        My paper on engineering LaCAM∗ for MAPF has been accepted to AAMAS-24!
      ja: |
        主著論文がAAMAS-24 に採択されました! マルチエージェント経路計画アルゴリズムLaCAM*の拡張についてです。
    url: https://www.aamas2024-conference.auckland.ac.nz/
    year: 2023
  - month: 11
    name:
      en: Seminar talk at the University of Cambridge
      ja: ケンブリッジ大学で講演を行いました
    url: https://www.cst.cam.ac.uk/seminars/list/204508
    year: 2023
  - month: 8
    name:
      en: Two talks at IJCAI-23 in Macao
      ja: IJCAI-23@マカオで2件の研究発表を行いました
    url: https://ijcai-23.org/
    year: 2023
  - month: 8
    name:
      en: |
        My PhD dissertation is finally out!
      ja: |
        博士論文が公開されました
    url: https://kei18.github.io/phd-dissertation/
    year: 2023
  - month: 8
    name:
      en: |
        A preprint paper "Engineering LaCAM∗: Towards Real-Time, Large-Scale, and Near-Optimal Multi-Agent Pathfinding" is out on arXiv.
      ja: |
        主著論文 "Engineering LaCAM∗: Towards Real-Time, Large-Scale, and Near-Optimal Multi-Agent Pathfinding"のプレプリントをarXivに公開しました.
    url: https://kei18.github.io/lacam3/
    year: 2023
  - month: 6
    name:
      en: Invited talk at SSII-23
      ja: 画像センシングシンポジウム(SSII)のオーガナイズドセッション「ロボット分野のCV技術」で講演を行いました
    url: https://confit.atlas.jp/guide/event/ssii2023/static/organized
    year: 2023
  - month: 5
    name:
      en: One talk (CTRMs) at ICRA-23 workshop on Multi-Robot Learning
      ja: ICRA-23 workshop on Multi-Robot Learning で CTRMs の発表を行いました
    url: https://sites.google.com/cam.ac.uk/multirobotlearningworkshopicra/home
    year: 2023
  - month: 5
    name:
      en: |
        Our paper "Solving Simultaneous Target Assignment and Path Planning Efficiently with Time-Independent Execution" has been published at Artificial Intelligence (AIJ)!
      ja: |
        主著論文 "Solving Simultaneous Target Assignment and Path Planning Efficiently with Time-Independent Execution" が Artificial Intelligence (AIJ) に掲載されました
    url: https://www.sciencedirect.com/science/article/pii/S0004370223000929
    year: 2023
  - month: 5
    name:
      en: Starting my research at the University of Cambridge, UK. I will stay here for two years.
      ja: イギリス・ケンブリッジ大学での研究活動を開始しました。2年間滞在予定です。
    url: https://www.cst.cam.ac.uk/
    year: 2023
  - month: 4
    name:
      en: |
        Our two papers "Quick Multi-Robot Motion Planning by Combining Sampling and Search," "Improving LaCAM for Scalable Eventually Optimal Multi-Agent Pathfinding" have been accepted to IJCAI-23!
      ja: |
        主著論文2報 "Quick Multi-Robot Motion Planning by Combining Sampling and Search," "Improving LaCAM for Scalable Eventually Optimal Multi-Agent Pathfinding" が IJCAI-23 に採択されました!
    url: https://ijcai-23.org/
    year: 2023
  - month: 4
    name:
      en: Our paper "Offline Time-Independent Multiagent Path Planning" has been published at IEEE Transactions on Robotics (T-RO)!
      ja: 主著論文 "Offline Time-Independent Multiagent Path Planning" が IEEE Transactions on Robotics (T-RO) に掲載されました
    url: https://ieeexplore.ieee.org/document/10092929
    year: 2023
  - month: 4
    name:
      en: Started a new career as a researcher at AIST, Japan
      ja: 産業技術総合研究所 人工知能研究センターの研究員に着任しました
    year: 2023
    url:
      en: https://www.aist.go.jp/index_en.html
      ja: https://www.aist.go.jp/
  - month: 3
    name:
      en: I finally got my Ph.D. from TokyoTech! Thanks to all who supported me
      ja: 東京工業大学から博士(工学)を授与されました! 支援していただいた皆さま、ありがとうございました
    year: 2023
  - month: 3
    name:
      en: Visited Kyushu University, Japan. Nice research discussions!
      ja: 九州大学を訪問しました
    # url:
    year: 2023
  - month: 2
    name:
      en: Visited Carnegie Mellon University, USA. Nice research discussions!
      ja: アメリカ・カーネギーメロン大学を訪問しました
    # url:
    year: 2023
  - month: 2
    name:
      en: Two talks at AAAI-23 in Washington DC, USA
      ja: AAAI-23@アメリカ・ワシントンDCで研究発表を行いました
    url: https://aaai.org/Conferences/AAAI-23/
    year: 2023
  - month: 1
    name:
      en: |
        PhD defense, entitled "Planning, Execution, Representation, and Their Integration for Multiple Moving Agents"
      ja: |
        博士論文発表会を行いました (題目: "Planning, Execution, Representation, and Their Integration for Multiple Moving Agents")
    url: https://educ.titech.ac.jp/cs/event_information/2023/063649.html
    year: 2023
  - month: 11
    name:
      en: |
        Our two papers "Fault-Tolerant Offline Multi-Agent Path Planning," "LaCAM: Search-Based Algorithm for Quick Multi-Agent Pathfinding" have been accepted to AAAI-23!
      ja: |
        主著論文2報 "Fault-Tolerant Offline Multi-Agent Path Planning," "LaCAM: Search-Based Algorithm for Quick Multi-Agent Pathfinding" が AAAI-23 に採択されました!
    url: https://aaai.org/Conferences/AAAI-23/
    year: 2022
  - month: 9
    name:
      en: Received offers of JSPS { Overseas Research, PD } Fellowships
      ja: 日本学術振興会 海外特別研究員および特別研究員PDに内定しました
    url:
      en: https://www.jsps.go.jp/english/e-ab/index.html
      ja: https://www.jsps.go.jp/j-ab/
    year: 2022
  - month: 9
    name:
      en: Finished research activities at Sorbonne Univ., back to Tokyo from Paris
      ja: ソルボンヌ大での滞在を終えてパリから東京に戻りました
    year: 2022
  - month: 9
    name:
      en: |
        Got a research grant: ACT-X "AI powered Research Innovation / Creation"
      ja: ACT-X「AI活用で挑む学問の革新と創成」に採択されました
    url: https://www.jst.go.jp/kisoken/act-x/application/2022/220920/220920.html
    year: 2022
  - month: 9
    name:
      en: One talk at MaC-22 in Pisa, Italy
      ja: MaC-22@イタリア・ピサで研究発表を行いました
    url: http://sbrinz.di.unipi.it/peppe/MAC2022/MAC2022.html
    year: 2022
  - month: 9
    name:
      en: Seminar talk at the VUB AI lab, Belgium
      ja: VUB AI Lab@ベルギー・ブリュッセル自由大学を訪問してセミナートークを行いました
    url: https://ai.vub.ac.be/
    year: 2022
  - month: 8
    name:
      en: Seminar talk at HyCoDeV Lab at Newcastle University, UK
      ja: HyCoDeV Lab@イギリス・ニューカッスル大を訪問してセミナートークを行いました
    url: https://hycodev.com/
    year: 2022
  - month: 8
    name:
      en: Seminar talk at Prorok Lab at the University of Cambridge, UK
      ja: Prorok Lab@イギリス・ケンブリッジ大を訪問してセミナートークを行いました
    url: https://www.proroklab.org/
    year: 2022
  - month: 7
    name:
      en: One talk at IJCAI-22 in Vienna, Austria
      ja: IJCAI-22@オーストリア・ウィーンで主著論文の研究発表を行いました
    url: https://ijcai-22.org/
    year: 2022
  - month: 7
    name:
      en: Invited talk "Navigation for a team of agents" at the 27th CoRe Seminar
      ja: 「エージェント群のナビゲーション」と題して組合せ遷移・第27回セミナーで招待講演を行いました
    url:
      en: https://core.dais.is.tohoku.ac.jp/en/report/event/detail/---id-125.html
      ja: https://core.dais.is.tohoku.ac.jp/report/event/detail/---id-124.html
    year: 2022
  - month: 7
    name:
      en: Our paper "Priority Inheritance with Backtracking for Iterative Multi-agent
        Path Finding" has been published at Artificial Intelligence (AIJ)!
      ja: 主著論文 "Priority Inheritance with Backtracking for Iterative Multi-agent Path
        Finding" が Artificial Intelligence (AIJ) に掲載されました
    url: https://www.sciencedirect.com/science/article/pii/S0004370222000923
    year: 2022
  - month: 7
    name:
      en: '"Awesome CS-Ja PhD Life" is out on GitHub!'
      ja: '"Awesome CS-Ja PhD Life"というCS博士課程のサバイブに役立ちそうな記事リストを公開しました'
    url: https://github.com/Kei18/awesome_cs-ja_phd_life
    year: 2022
  - month: 6
    name:
      en: One talk at ICAPS-22
      ja: ICAPS-22 で主著論文の研究発表を行いました
    url: http://icaps22.icaps-conference.org/
    year: 2022
  - month: 5
    name:
      en: One talk at AAMAS-22
      ja: AAMAS-22 で主著論文の研究発表を行いました
    url: https://aamas2022-conference.auckland.ac.nz/
    year: 2022
  - month: 5
    name:
      en: Surprisingly got the ICAPS 2022 Best Student Paper Award! Many thanks to Xavier
        and anonymous reviewers who gave me many constructive comments in the submissions.
      ja: The ICAPS 2022 Best Student Paper Awardを受賞しました! Defago先生と建設的なコメントをしていただいた匿名査読者の方々に感謝します.
    url: https://icaps22.icaps-conference.org/awards.html
    year: 2022
  - month: 4
    name:
      en: Our paper "Offline Time-Independent Multi-Agent Path Planning" has been accepted
        to IJCAI-22!
      ja: 主著論文 "Offline Time-Independent Multi-Agent Path Planning" が IJCAI-22 に採択されました!
    url: https://ijcai-22.org/
    year: 2022
  - month: 3
    name:
      en: Starting my research at LIP6, Sorbonne University in Paris
      ja: ソルボンヌ大学(パリ)での研究活動を開始しました
    url: https://www.lip6.fr
    year: 2022
  - month: 3
    name:
      en: A preprint paper "Quick Multi-Robot Motion Planning by Combining Sampling
        and Search" is out on arXiv.
      ja: 主著論文 "Quick Multi-Robot Motion Planning by Combining Sampling and Search"
        のプレプリントをarXivに公開しました.
    url: https://kei18.github.io/sssp/
    year: 2022
  - month: 2
    name:
      en: Our paper "Solving Simultaneous Target Assignment and Path Planning Efficiently
        with Time-Independent Execution" has been accepted to ICAPS-22!
      ja: 主著論文 "Solving Simultaneous Target Assignment and Path Planning Efficiently
        with Time-Independent Execution" が ICAPS-22 に採択されました!
    url: http://icaps22.icaps-conference.org/
    year: 2022
  - month: 2
    name:
      en: Start research internship at LIP6, Sorbonne University, supervised by Prof.
        Sebastien Tixeuil
      ja: LIP6@ソルボンヌ大学, Tixeuil Sebastien 教授の下でインターンシップ(リモート)を始めました. 3月半ばから滞在予定です.
    url: https://www.lip6.fr/
    year: 2022
  - month: 12
    name:
      en: 'Our paper "CTRMs: Learning to Construct Cooperative Timed Roadmaps for Multi-agent
        Path Planning in Continuous Spaces", the outcome of my internship at OSX, has
        been accepted to AAMAS-22!'
      ja: '主著論文 "CTRMs: Learning to Construct Cooperative Timed Roadmaps for Multi-agent
        Path Planning in Continuous Spaces" が AAMAS-22 に採択されました! インターン@OSX での成果です.'
    url: https://aamas2022-conference.auckland.ac.nz/
    year: 2021
  - month: 11
    name:
      en: Received an offer of JSPS Overseas Challenge Program for Young Researchers
      ja: 日本学術振興会 若手研究者海外挑戦プログラムに内定しました
    url: https://www.jsps.go.jp/j-abc/index.html
    year: 2021
  - month: 11
    name:
      en: A preprint paper "Priority Inheritance with Backtracking for Iterative Multi-agent
        Path Finding", an extended version of IJCAI-19 for a journal, is out on arXiv.
      ja: 主著論文 "Priority Inheritance with Backtracking for Iterative Multi-agent Path
        Finding" のプレプリントをarXivに公開しました. IJCAI-19 をジャーナル用に拡張しています
    url: https://kei18.github.io/pibt2/
    year: 2021
  - month: 10
    name:
      en: Got Nomination Award of the 2021 Microsoft Research Asia Fellowship
      ja: 2021 Microsoft Research Asia Fellowship の Nomination Award を受賞しました
    url: https://www.microsoft.com/en-us/research/lab/microsoft-research-asia/articles/eleven-phd-students-are-awarded-the-2021-microsoft-research-asia-fellowship-award/
    year: 2021
  - month: 10
    name:
      en: Finish internship at OMRON SINIC X
      ja: OMRON SINIC X でのインターンを終えました. 非常に良い経験でした
    url: https://www.omron.com/sinicx/
    year: 2021
  - month: 9
    name:
      en: One talk at IROS-21
      ja: IROS-21 で主著論文の発表を行いました
    url: https://www.iros2021.org/
    year: 2021
  - month: 9
    name:
      en: One talk at WTCS-21. I got an outstanding presentation award!
      ja: WTCS-21 で研究発表を行い, 優秀プレゼンテーション賞を受賞しました
    url: https://w-tcs.github.io/2021/
    year: 2021
  - month: 9
    name:
      en: A preprint paper "Solving Simultaneous Target Assignment and Path Planning
        Efficiently with Time-Independent Execution" is out on arXiv
      ja: 主著論文 "Solving Simultaneous Target Assignment and Path Planning Efficiently
        with Time-Independent Execution" のプレプリントをarXivに公開しました
    url: https://arxiv.org/abs/2109.04264
    year: 2021
  - month: 8
    name:
      en: Our paper "Roadside-assisted Cooperative Planning using Future Path Sharing
        for Autonomous Driving" has been accepted to VTC2021-Fall!
      ja: 共著論文 "Roadside-assisted Cooperative Planning using Future Path Sharing for
        Autonomous Driving" が VTC2021-Fall に採択されました!
    url: https://events.vtsociety.org/vtc2021-fall/
    year: 2021
  - month: 7
    name:
      en: Our paper "Iterative Refinement for Real-Time Multi-Robot Path Planning" has
        been accepted to IROS-21!
      ja: 主著論文 "Iterative Refinement for Real-Time Multi-Robot Path Planning" が IROS-21
        に採択されました!
    url: https://www.iros2021.org/
    year: 2021
  - month: 6
    name:
      en: One talk at JSAI-21
      ja: JSAI-21 にて研究発表を行いました
    url: https://www.ai-gakkai.or.jp/jsai2021/
    year: 2021
  - month: 6
    name:
      en: One talk at ICRA-21
      ja: ICRA-21 で共著論文の発表を行いました
    url: https://www.ieee-icra.org/
    year: 2021
  - month: 5
    name:
      en: A preprint paper "Offline Time-Independent Multi-Agent Path Planning" is out
        on arXiv
      ja: 主著論文 "Offline Time-Independent Multi-Agent Path Planning" のプレプリントをarXivに公開しました
    url: https://arxiv.org/abs/2105.07132
    year: 2021
  - month: 4
    name:
      en: Start research internship at OSX (OMRON SINIC X)
      ja: OSX (OMRON SINIC X) でインターンシップを始めました. プランニングx機械学習の研究に従事する予定です.
    url: https://www.omron.com/sinicx/
    year: 2021
  - month: 4
    name:
      en: Got an award at the Fixstars Amplify Hackathon
      ja: Fixstars Amplify ハッカソンで「Champlify」が優秀賞を受賞しました
    url: https://amplify.fixstars.com/hackathon00
    year: 2021
  - month: 3
    name:
      en: One invited talk at the 116th SIG-FPAI
      ja: 第116回人工知能基本問題研究会(SIG-FPAI)にて招待講演を行いました
    url: https://sig-fpai.org/past/fpai116.html
    year: 2021
  - month: 3
    name:
      en: One talk at IPSJ-21
      ja: IPSJ-21にて研究発表を行いました
    url: https://www.ipsj.or.jp/event/taikai/83/
    year: 2021
  - month: 3
    name:
      en: Our paper "Active Modular Environment for Robot Navigation" has been accepted
        to ICRA-21!
      ja: 共著論文 "Active Modular Environment for Robot Navigation" がICRA-21に採択されました!
    url: http://www.icra2021.org/
    year: 2021
  - month: 2
    name:
      en: A preprint paper "Iterative Refinement for Real-Time Multi-Robot Path Planning"
        is out on arXiv
      ja: 主著論文 "Iterative Refinement for Real-Time Multi-Robot Path Planning" のプレプリントをarXivに公開しました
    url: https://arxiv.org/abs/2102.12331
    year: 2021
  - month: 2
    name:
      en: One talk at AAAI-21
      ja: AAAI-21で主著論文の発表を行いました
    url: https://aaai.org/Conferences/AAAI-21/
    year: 2021
  - month: 1
    name:
      en: 'One talk "winPIBT: Extended Prioritized Algorithm for Iterative Multi-agent
        Path Finding" at WoMAPF-20'
      ja: '主著論文 "winPIBT: Extended Prioritized Algorithm for Iterative Multi-agent Path
        Finding"を WoMAPF-20 にて発表しました'
    url: http://idm-lab.org/wiki/IJCAI20-MAPF/
    year: 2021
  - month: 12
    name:
      en: Our paper "Time-Independent Planning for Multiple Moving Agents" has been
        accepted to AAAI-21!
      ja: 主著論文 "Time-Independent Planning for Multiple Moving Agents" がAAAI-21に採択されました!
    url: https://aaai.org/Conferences/AAAI-21/
    year: 2020
  - month: 10
    name:
      en: I attended to ICAPS-20 Summer School on Automated Planning & Scheduling
      ja: ICAPS-20 Summer School on Automated Planning & Schedulingに参加しました
    url:
      en: https://icaps20subpages.icaps-conference.org/students/summer-school/
      ja: https://kei18.github.io/posts/20201017_ICAPS-Summer-School.html
    year: 2020
  - month: 9
    name:
      en: One talk at WTCS-20. I got an outstanding presentation award
      ja: WTCS-20で研究発表を行い, 優秀プレゼンテーション賞を受賞しました
    url: https://w-tcs.github.io/2020/
    year: 2020
  - month: 7
    name:
      en: Selected as JASSO Repayment Exemption for Students with Excellent Grades
      ja: 日本学生支援機構 第一種奨学金 全額返済免除が決まりました
    url: https://www.jasso.go.jp/shogakukin/taiyochu/gyosekimenjyo/index.html
    year: 2020
  - month: 6
    name:
      en: An interview article has been published at "someone vol.51"
      ja: someone vol.51という中高生向けの科学冊子にインタビュー記事が掲載されました
    url: https://lne.st/business/publishing/someone/
    year: 2020
  - month: 4
    name:
      en: Our paper "Investigating the Hand Ownership Illusion with Two Views Merged
        in" has been published at Frontiers in Robotics and AI!
      ja: 主著論文 "Investigating the Hand Ownership Illusion with Two Views Merged in"
        が Frontiers in Robotics and AI に掲載されました
    url: https://www.frontiersin.org/articles/10.3389/frobt.2020.00049/full
    year: 2020
  - month: 4
    name:
      en: I got an M.Eng in CS and a graduate minor in physics from the TokyoTech. I
        also start my Ph.D. course
      ja: 東京工業大学の修士課程(工学, 副専門:物理学)を終了し, 博士課程(情報理工学院)に進学しました
    year: 2020
  - month: 11
    name:
      en: One invited talk at WDALFR-19
      ja: WDALFR-19にて招待講演を行いました
    url: https://sites.google.com/view/wdalfr/the-1st-wdalfr2019
    year: 2019
  - month: 9
    name:
      en: Received an offer of JSPS Research Fellow DC1
      ja: 日本学術振興会特別研究員DC1に内定しました
    url:
      en: https://www.jsps.go.jp/english/e-pd/index.html
      ja: https://www.jsps.go.jp/j-pd/
    year: 2019
  - month: 9
    name:
      en: One talk at FIT-19
      ja: FIT-19にて研究発表を行いました
    url: https://www.ipsj.or.jp/event/fit/fit2019/
    year: 2019
  - month: 9
    name:
      en: One talk at WTCS-19. I got the best research award!
      ja: WTCS-19で研究発表を行い, 最優秀講演賞を受賞しました
    url: https://w-tcs.github.io/2019/
    year: 2019
  - month: 8
    name:
      en: One talk at IJCAI-19
      ja: IJCAI-19にて主著論文の発表を行いました
    url: https://ijcai19.org/
    year: 2019
  - month: 6
    name:
      en: Selected as Yoshida Scholarship Foundation Doctor21
      ja: 吉田育英会ドクター21に内定しました
    url: https://www.ysf.or.jp/scholarship/visitor/internal/doctor21.php
    year: 2019
  - month: 6
    name:
      en: Our paper "Priority Inheritance with Backtracking for Iterative Mulit-agent
        Path Finding" has been accepted to IJCAI-19!
      ja: 主著論文 "Priority Inheritance with Backtracking for Iterative Mulit-agent Path
        Finding" がIJCAI-19に採択されました
    url: https://ijcai19.org/
    year: 2019
  - month: 12
    name:
      en: One talk at SI-18
      ja: SI-18で研究発表を行いました
    url: https://www.sice-si.org/conf/si2018/
    year: 2018
  - month: 9
    name:
      en: One talk at iCAST-18
      ja: iCAST-18で研究発表を行いました
    url: http://www.design.kyushu-u.ac.jp/~icast/
    year: 2018
  - month: 8
    name:
      en: research internship at NEC Data Science Lab
      ja: NECデータサイエンス研究所でインターンシップを始めました
    year: 2018
  - month: 8
    name:
      en: 'Our paper "Amoeba Exploration: Coordinated Exploration with Distributed Robots"
        has been accepted to iCAST-18!'
      ja: '主著論文 "Amoeba Exploration: Coordinated Exploration with Distributed Robots"
        がiCAST-18に採択されました'
    url: http://www.design.kyushu-u.ac.jp/~icast/
    year: 2018
  - month: 6
    name:
      en: One talk at IMRF-18
      ja: IMRF-18にて研究発表を行いました
    url: https://imrf.info/wp_imrf/timetable/category/imrf-2018/
    year: 2018
  - month: 4
    name:
      en: I got an B.Eng in CS from the TokyoTech. I also start my master course
      ja: 東京工業大学の学士課程(工学)を終了し, 修士課程(情報理工学院)に進学しました
    year: 2018
